import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Admin routes use a separate token stored under `admin_token`.  Everything
// else uses the customer `auth_token`.  A single axios instance is shared so
// interceptors below pick the right credential per request.
const isAdminPath = (url) => (url || "").startsWith("/admin");

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const key = isAdminPath(url) ? "admin_token" : "auth_token";
  const token = localStorage.getItem(key);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    if (r && r.data == null) {
      const url = (r.config?.url || "").toLowerCase();
      const looksLikeList =
        /\/(customers|vendors|jobs|purchases|payments|categories|cash-transfers|incomes|expenses|movements|notes)(\?|$)/.test(url);
      r.data = looksLikeList ? [] : {};
    }
    return r;
  },
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      const path = window.location.pathname;
      if (isAdminPath(url)) {
        // Admin session invalid → send back to the admin login page.
        if (!path.startsWith("/admin/login")) {
          localStorage.removeItem("admin_token");
          window.location.href = "/admin/login";
        }
      } else if (path !== "/login") {
        localStorage.removeItem("auth_token");
        window.location.href = "/login";
      }
    } else if (err?.response?.status === 402) {
      // Trial süresi dolmuş veya yaşam döngüsü nedeniyle iş modüllerine
      // erişimi kısıtlanmış kullanıcı — durum koduna göre doğru ekrana
      // yönlendir.  Ödeme ve auth endpoint'leri hâlâ erişilebilir.
      const code = err?.response?.data?.detail?.code || "";
      const path = window.location.pathname;
      // Deleted kullanıcıya ödeme ekranı ASLA gösterilmez; özel silinme
      // uyarı ekranına yönlendirilir.
      if (code === "account_deleted") {
        const allowedForDeleted = ["/hesap-silinme-surecinde", "/login"];
        if (!allowedForDeleted.some((p) => path.startsWith(p))) {
          window.location.href = "/hesap-silinme-surecinde";
        }
      } else {
        // trial_expired, frozen, expired, account_passive, account_archived
        // → mevcut abonelik/ödeme ekranı.
        const paymentPaths = ["/abonelik", "/odeme/basarili", "/odeme/basarisiz", "/login"];
        if (!paymentPaths.some((p) => path.startsWith(p))) {
          window.location.href = "/abonelik";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
